import { render } from "./NewRegister.vue?vue&type=template&id=70c26a7a&ts=true"
import script from "./NewRegister.vue?vue&type=script&lang=ts"
export * from "./NewRegister.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/crud/infrastructure/search/NewRegister.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70c26a7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70c26a7a', __exports__)) {
    api.reload('70c26a7a', __exports__)
  }
  
  module.hot.accept("./NewRegister.vue?vue&type=template&id=70c26a7a&ts=true", () => {
    api.rerender('70c26a7a', render)
  })

}


export default __exports__